import React, { type ForwardedRef, forwardRef, useImperativeHandle, useRef, useState } from 'react';

import {
    DisplayToggle,
    StyledFilterHeadingContainer,
    StyledFilterHeadingTitle,
    StyledFilterHeadingTitleContainer,
} from './styles';

type FilterHeadingProps = {
    children?: React.ReactNode;
    suffixElement?: React.ReactNode;
    noPadding?: boolean;
    disableUpperCase?: boolean;
};

export const FilterHeading = forwardRef(
    (
        { children, noPadding, suffixElement, disableUpperCase, ...props }: FilterHeadingProps,
        forwardedRef: ForwardedRef<HTMLHeadingElement>,
    ) => {
        const targetRef = useRef<HTMLHeadingElement>(null);
        useImperativeHandle(forwardedRef, () => targetRef.current as HTMLHeadingElement);
        const [isExpanded, setIsExpanded] = useState(false);
        const toggle = () => {
            setIsExpanded((c) => !c);
        };

        return (
            <StyledFilterHeadingContainer>
                <StyledFilterHeadingTitle
                    $noPadding={noPadding}
                    $disableUpperCase={disableUpperCase}
                    {...props}
                    ref={targetRef}
                >
                    <StyledFilterHeadingTitleContainer>
                        {children}
                        {suffixElement}
                    </StyledFilterHeadingTitleContainer>
                    <DisplayToggle onClick={toggle}>{isExpanded ? '-' : '+'}</DisplayToggle>
                </StyledFilterHeadingTitle>
            </StyledFilterHeadingContainer>
        );
    },
);

FilterHeading.displayName = 'FilterHeading';
